import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { Component, Inject, ChangeDetectionStrategy } from "@angular/core";
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle
} from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";
import { Author, Kudos, TimelineItemDialogService } from "@teammood/timeline";
import { distinctUntilChanged, filter, map, takeUntil, tap } from "rxjs";
import { ITeam } from "@teammood/team";

@Component({
    selector: 'tm-create-custom-kudos-dialog',
    templateUrl: 'create-custom-kudos-dialog.component.html',
    styleUrls: ['./../../../timeline-item.scss', './../create-kudos-dialog/create-kudos-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        TranslateModule,
        OverlayModule,
    ]
})
export class TmCreateCustomKudosDialogComponent {

    protected isHandset$ =  this.breakpointObserver.observe([
        Breakpoints.Handset,
    ]).pipe(
        map(result => result.matches),
        distinctUntilChanged()
    )

    overlayPositions: ConnectedPosition[] = [
        {
          originX: 'end',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'top',
        }
    ]
    
    constructor(
        @Inject(MAT_DIALOG_DATA) protected dialogInput: CreateCustomKudosDialogData,
        private dialogRef: MatDialogRef<TmCreateCustomKudosDialogComponent, Kudos>,
        private breakpointObserver: BreakpointObserver,
        private timelineItemDialogService: TimelineItemDialogService
    ) {
    }

    protected close() {
        this.dialogRef.close();
    }

    protected onClose() {
        this.dialogRef.close();
    }

    protected async startKudos() {
        const kudosDialogRef = await this.timelineItemDialogService.createKudos(this.dialogInput.teams, this.dialogInput.author, true);

        kudosDialogRef.beforeClosed().pipe(
            filter((kudos) => !!kudos),
            tap(kudos => this.dialogRef.close(kudos)),
            takeUntil(kudosDialogRef.afterClosed())
        ).subscribe();
    }
}

interface CreateCustomKudosDialogData {
    teams: ITeam[],
    customKudos: {
        ctaLabel: string,
        ctaUrl: string,
        descriptionLine1: string,
        descriptionLine2: string,
    },
    author: Author
}
